import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export function useGetMetadataInfo() {
  const store = useStore();
  const route = useRoute();
  const scoreSetData = computed(() => store.getters['scoreSet/getScoreSet']);

  const patientID = computed(() => scoreSetData.value?.patientID ?? '-');
  const dateOfBirth = computed(() => scoreSetData.value?.dateOfBirth ?? '-');
  const fullName = computed(() => scoreSetData.value?.fullName ?? '-');
  const studyId = computed(() => route.params.id as string);
  const purpose = computed(() => scoreSetData.value?.purpose);
  const purposeType = computed(() => scoreSetData.value?.purposeType);
  const desaturationRule = computed(() => scoreSetData.value?.desaturationRule);
  const studyConfiguration = computed(() => scoreSetData.value?.studyConfiguration ?? '-');
  const notes = computed(() => scoreSetData.value?.notes ?? '-');
  const ecgPolarityInversion = computed(() => scoreSetData.value?.ecgPolarityInversion);

  return {
    patientID,
    dateOfBirth,
    fullName,
    studyId,
    purpose,
    purposeType,
    desaturationRule,
    studyConfiguration,
    notes,
    ecgPolarityInversion
  };
}
